// extracted by mini-css-extract-plugin
export default {"alert-content":"V1PG_rA7GWfHEN2l7HiS","alertContent":"V1PG_rA7GWfHEN2l7HiS","alert-action":"TlLRgWrHj3bpFDGqEsuQ","alertAction":"TlLRgWrHj3bpFDGqEsuQ"};